import check_checkbox from '../../wp-content/themes/Heimdall/source/js/contact-form-gdpr.js';
import {
  max_height_double_image_block,
  image_text_fill_height,
  animate_achievement,
  animate_number_when_scrolling,
  imagebank_block_functionality,
  embed_video,
  block_column_images,
  block_column_fullwidth,
  image_gallery
 } from '../../wp-content/themes/Heimdall/source/js/wp_block_scripts.js';
 import { feature_block }from '../../wp-content/themes/Heimdall/source/js/block/feature-block';
 import {
   hide_site_header,
   important_notice,
   submenu_btn,
   remove_navigation_class,
   sticky_scroll,
   left_or_right_menu
 } from '../../wp-content/themes/Heimdall/source/js/header';
 import { footer_popop } from '../../wp-content/themes/Heimdall/source/js/footer';
 import { mobile_menu_toggle_btn, mobile_language_selector } from '../../wp-content/themes/Heimdall/source/js/mobile-menu';
 import { scale_hero_text, scale_text } from '../../wp-content/themes/Heimdall/source/js/text';
 import mobile_menu from '../../wp-content/themes/Heimdall/source/js/mobile-menu.js';

 export default function heimdall_wp() {
  //submenu_btn();
  scale_hero_text();
  scale_text();
  check_checkbox();
  max_height_double_image_block();
  image_text_fill_height();
  imagebank_block_functionality();
  embed_video();
  image_gallery();
  animate_number_when_scrolling();
  important_notice();
  footer_popop();
  feature_block();
  mobile_menu_toggle_btn();
  mobile_language_selector();
  hide_site_header();
  left_or_right_menu();

  $(window).on('resize', (event) => {
    // embed();
    max_height_double_image_block();
    remove_navigation_class();
  });

  $(window).scroll((event) => {
    animate_number_when_scrolling();
    sticky_scroll();
  });

  $(window).load((event) => {
    block_column_images();
    block_column_fullwidth();
  });

  // burger_menu();

}
